module.exports = __webpack_public_path__ + "teqbahn-assets/media/Africa.54b70e9b.jpg";